import React from 'react';
import { Bell, Code, Pencil } from 'lucide-react';
import { RunStatePill } from '../../components/EtlPages';
import {
  ActionSheet, SheetKv, SheetActions, SheetAction, timeAgo,
} from '../../components/FileTracking/EtlMobileKit';
import { stageLabel } from '../../components/FileTracking/DlqCardList';

/**
 * The row actions of the Feeds table, as a bottom sheet for phones: what the
 * feed matches on and how it runs, then Settings (alert schedule and
 * recipients), the raw JSON config and the wizard — the same three icon
 * buttons the desktop row carries, with the same handlers.
 */
export default function FeedActionSheet({
  row, open, onOpenChange, locationName, extractionLabel, schemaBuilderEnabled, rawLoading,
  onConfigure, onRawJson, onEdit,
}) {
  if (!row) return null;
  const extraction = row.lastRun?.ocrService || row.ocrService;
  const keywords = (row.keywords || []).join(', ');
  const excludes = (row.excludeKeywords || []).join(', ');
  const lastError = row.lastRun?.lastErrorMessage;
  const received = row.lastRun?.receivedAt;

  return (
    <ActionSheet
      open={open}
      onOpenChange={onOpenChange}
      title={row.fileType}
      titleClassName="ep-cap"
      subtitle={[locationName, row.hotelCode].filter(Boolean).join(' · ')}
      meta={<RunStatePill status={row.lastRun?.status || 'never'} />}
    >
      {lastError ? (
        <div className="ep-m-error" role="note">
          {row.lastRun.lastErrorStage ? <span className="ep-m-error-stage">{stageLabel(row.lastRun.lastErrorStage)}</span> : null}
          {lastError}
        </div>
      ) : null}

      <SheetKv
        rows={[
          {
            label: 'Matches on',
            value: keywords ? `${keywords} ${row.matchType === 'subject' ? '(subject)' : '(file name)'}` : null,
          },
          { label: 'Excludes', value: excludes || null },
          { label: 'Formats', value: row.allowedExtensions?.length ? row.allowedExtensions.join(', ') : 'Any' },
          { label: 'Arrives by', value: row.method === 'sftp' ? 'SFTP' : 'Email' },
          { label: 'Extraction', value: extraction ? extractionLabel(extraction) : null },
          { label: 'Function', value: row.etlFunction || null },
          { label: 'Alerts', value: row.trackingEnabled ? 'On' : 'Off' },
          { label: 'Last received', value: received ? `${timeAgo(received)} · ${new Date(received).toLocaleDateString()}` : 'Never' },
        ]}
      />

      <SheetActions label="Feed actions">
        <SheetAction icon={Bell} onClick={onConfigure}>Alert schedule and recipients</SheetAction>
        <SheetAction icon={Code} onClick={onRawJson} disabled={rawLoading}>
          {rawLoading ? 'Loading raw JSON…' : 'Raw JSON config'}
        </SheetAction>
        {schemaBuilderEnabled ? (
          <SheetAction icon={Pencil} tone="primary" onClick={onEdit}>Edit in wizard</SheetAction>
        ) : null}
      </SheetActions>
    </ActionSheet>
  );
}
